module.exports = __webpack_public_path__ + "img/icon_QQQ.9935fce2.png";